import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-5dade13c"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "experience",
  class: "mb-16"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "section-title" }, "Experiencia Profesional", -1))
const _hoisted_3 = { class: "flex flex-col md:flex-row md:items-baseline md:justify-between gap-1 mb-1" }
const _hoisted_4 = { class: "font-serif-display text-xl text-ink" }
const _hoisted_5 = { class: "text-subtle font-body text-base" }
const _hoisted_6 = { class: "font-mono-label text-xs text-subtle whitespace-nowrap" }
const _hoisted_7 = { class: "font-semibold text-ink text-sm mb-1" }
const _hoisted_8 = { class: "text-subtle text-sm leading-relaxed max-w-[70ch] mb-2" }
const _hoisted_9 = { class: "font-mono-label text-[0.7rem] uppercase tracking-[0.08em] text-indigo2" }

import { ref } from 'vue';

interface Proyecto {
  titulo: string;
  descripcion: string;
  tecnologias: string[];
}

interface Experiencia {
  empresa: string;
  rol: string;
  periodo: string;
  proyectos: Proyecto[];
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ExperienciaProfesional',
  setup(__props) {

const experiencias = ref<Experiencia[]>([
  {
    empresa: 'TechyWe',
    rol: 'Java Backend Developer',
    periodo: 'Mayo 2025 — Presente',
    proyectos: [
      {
        titulo: 'Banco Hipotecario (BH)',
        descripcion:
          'Incorporación a un middleware existente de procesamiento por lotes y asignación de productos, construido con Java Spring Boot y Maven. Análisis técnico, corrección de errores y mejoras de código en backend y base de datos. Mantenimiento en producción, resolviendo incidentes reportados.',
        tecnologias: ['Java Spring Boot', 'Maven', 'SQL', 'Producción'],
      },
      {
        titulo: 'Billing RUBRIDOC',
        descripcion:
          'Desarrollo y mantenimiento de un sistema de facturación electrónica en producción, construido con Java Spring Boot, Maven y AWS S3 para almacenamiento de documentos. Nuevas funcionalidades REST, optimización de procesos y resolución de bugs críticos.',
        tecnologias: ['Java Spring Boot', 'Maven', 'AWS S3', 'REST APIs'],
      },
    ],
  },
  {
    empresa: 'QUANTO',
    rol: 'Full Stack Junior Developer',
    periodo: 'Abril 2024 — Mayo 2024',
    proyectos: [
      {
        titulo: 'Sistema de Gestión de Productos',
        descripcion:
          'Mantenimiento y corrección de errores en un sistema de gestión de productos. Responsable de identificar y resolver errores del sistema.',
        tecnologias: ['Angular 16', 'Ionic Framework'],
      },
    ],
  },
]);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", null, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(experiencias.value, (exp, index) => {
        return (_openBlock(), _createElementBlock("article", {
          key: index,
          class: "py-6 border-b border-hairline first:pt-0"
        }, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("h3", _hoisted_4, [
              _createTextVNode(_toDisplayString(exp.empresa) + " ", 1),
              _createElementVNode("span", _hoisted_5, "— " + _toDisplayString(exp.rol), 1)
            ]),
            _createElementVNode("span", _hoisted_6, _toDisplayString(exp.periodo), 1)
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(exp.proyectos, (proyecto, pIndex) => {
            return (_openBlock(), _createElementBlock("div", {
              key: pIndex,
              class: "mt-4"
            }, [
              _createElementVNode("h4", _hoisted_7, _toDisplayString(proyecto.titulo), 1),
              _createElementVNode("p", _hoisted_8, _toDisplayString(proyecto.descripcion), 1),
              _createElementVNode("p", _hoisted_9, _toDisplayString(proyecto.tecnologias.join(' · ')), 1)
            ]))
          }), 128))
        ]))
      }), 128))
    ])
  ]))
}
}

})